import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { environment } from 'src/environments/environment';
import { first } from 'rxjs/operators';

@Injectable()
export class DataService {

  private baseUrl = environment.apiBaseUrl;
  private vtsBaseUrl = environment.vtsBaseUrl;
  private weighBridgeUrl = environment.weighBridgeUrl;
  private cache: any = {};

  constructor(private http: HttpClient) {
  }

  getJsonData(filePath) {
    return this.http.get<any>(filePath);
  };

  getPdfData(filePath, responseType) {
    return this.http.get<any>(filePath, responseType);
  };

  getData(route, refresh) {
    if (this.dataForRouteIsCached(route, refresh)) {
      return Observable.of(this.cache[route]);
    } else { // no cached data or refresh requested
      return this.http.get<any>(this.baseUrl + route).map(response => {
        this.cache[route] = response;
        return response;
      });
    }
  }

  getWeatherData(route, refresh) {
    if (this.dataForRouteIsCached(route, refresh)) {
      return Observable.of(this.cache[route]);
    } else { // no cached data or refresh requested
      return this.http.get<any>(route).map(response => {
        this.cache[route] = response;
        return response;
      });
    }
  }

  getDataWithParams(route, params, refresh) {
    if (this.dataForRouteIsCached(route, refresh)) {
      return Observable.of(this.cache[route]);
    } else { // no cached data or refresh requested
      return this.http.get<any>(this.baseUrl + route, { params: params }).map(response => {
        this.cache[route] = response;
        return response;
      });
    }
  }

  getRecord(route) {
    return this.http.get<any>(this.baseUrl + route);
  }

  vtsGetRecord(route) {
    return this.http.get<any>(this.vtsBaseUrl + route);
  }

  getweighBridgeRecord(route) {
    return this.http.get<any>(this.weighBridgeUrl + route);
  }

  getVehicles() {
    return this.http.get<any>(this.baseUrl + "/api/view/vehicles");
  }

  getRecordWithParams(route, params) {
    return this.http.get<any>(this.baseUrl + route, { params: params });
  }

  postWithoutBaseUrl(route, data) {
    return this.http.post<any>(route, data);
  }

  post(route, data, headers?: HttpHeaders) {
    return this.http.post<any>(this.baseUrl + route, data, headers ? { headers } : undefined);
  }

  postAsPromise(route, data) {
    const res$ = this.http.post<any>(this.baseUrl + route, data).pipe(first());
    return res$.toPromise();
  }

  postGetCSV(route, data) {
    const headers = new HttpHeaders(
      {
        'Accept': 'text/csv',
      });
    return this.http.post<any>(this.baseUrl + route, data, { headers: headers, responseType: 'blob' as 'json' });
  }

  vtsPost(route, data) {
    return this.http.post<any>(this.vtsBaseUrl + route, data);
  }

  triggerWebhook(route, data: any): Observable<any> {
    return this.http.get<any>(this.baseUrl + route, data);
  }


  directPost(route, data) {
    return this.http.post<any>(route, data);
  }

  weightBridgepost(route, data) {
    const headers = new HttpHeaders({
      'show-weighobj-error': 'true'
    });

    return this.http.post<any>(
      route,
      data,
      { headers }
    );
  }

  delete(route) {
    return this.http.delete(this.baseUrl + route).map(response => {
      return response;
    });
  }

  getReport(route) {
    return this.http.get(this.baseUrl + route, { responseType: 'blob' });
  }



  getExternalData(route) {
    return this.http.get<any>(route).map(response => {
      return response;
    });
  }

  dataForRouteIsCached(route, refresh) {
    return this.cache[route] && (refresh === false || refresh === undefined);
  }

  getJSON(formId): Observable<any> {
    return this.http.get("./assets/" + formId + ".json");
  }

  clearCache() {
    this.cache = {};
  }

  clearRouteCache(route) {
    this.cache[route] = null;
  }
}
